module.exports = __webpack_public_path__ + "static/img/reward_effect_pre2.41459541.png";